import Button from "../../../../Custom/Button/Button";
import { Fragment, useState } from "react";
import { useGlobalContext } from "../../../../../Context/Context";

const style = {
  btn: {
    padding: "7px",
    fontWeight: "bold",
    textAlign: "left",
    minHeight: "64px",
    display: "block",
    fontSize: "16px"
  }
};

function PrikazListe({ data, setIsDodaj }) {
  // ""/"POSLOVNE_JEDINICE"/"GRADILISTA"/"RADILISTA"
  const [expanded, setExpanded] = useState("");

  const { dictionary, setSelectedPoslovnaJedinica, selectedPoslovnaJedinica } =
    useGlobalContext();

  const handleExpand = (key) => {
    setExpanded((prev) => (prev === key ? "" : key));
  };

  const handleClickPoslovnaJedinica = (id) => {
    setSelectedPoslovnaJedinica((prev) => (prev === id ? "" : id));
  };

  const isMoreThanOneType =
    Object.values(data).filter((items) => items && items.length > 0).length > 1;

  return (
    <div style={{ height: "500px", overflowY: "auto" }}>
      {Object.keys(data).map(
        (key, i) =>
          data[key].length > 0 && (
            <Fragment key={i}>
              {isMoreThanOneType && (
                <div onClick={() => handleExpand(key)}>
                  <Button active={expanded === key} style={style.btn}>
                    {dictionary[key]}
                  </Button>
                </div>
              )}
              {(!isMoreThanOneType || expanded === key) &&
                data[key].map((item) => (
                  <div
                    onClick={() => handleClickPoslovnaJedinica(item.id)}
                    key={item.id}
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Button
                      active={item.id === selectedPoslovnaJedinica}
                      style={{
                        ...style.btn,
                        width: isMoreThanOneType ? "90%" : "100%"
                      }}
                    >
                      {item.naziv}
                    </Button>
                  </div>
                ))}
            </Fragment>
          )
      )}
      <div onClick={() => setIsDodaj(true)}>
        <Button style={style.btn}>{dictionary["dodaj"]}</Button>
      </div>
    </div>
  );
}

export default PrikazListe;
